import request from '@/utils/request'


// 查询医院科室华歧系数变动记录列表
export function listDepartScoreRecord(query) {
  return request({
    url: '/hospital/departScoreRecord/list',
    method: 'get',
    params: query
  })
}

// 查询医院科室华歧系数变动记录分页
export function pageDepartScoreRecord(query) {
  return request({
    url: '/hospital/departScoreRecord/page',
    method: 'get',
    params: query
  })
}

// 查询医院科室华歧系数变动记录详细
export function getDepartScoreRecord(data) {
  return request({
    url: '/hospital/departScoreRecord/detail',
    method: 'get',
    params: data
  })
}

// 新增医院科室华歧系数变动记录
export function addDepartScoreRecord(data) {
  return request({
    url: '/hospital/departScoreRecord/add',
    method: 'post',
    data: data
  })
}

// 修改医院科室华歧系数变动记录
export function updateDepartScoreRecord(data) {
  return request({
    url: '/hospital/departScoreRecord/edit',
    method: 'post',
    data: data
  })
}

// 删除医院科室华歧系数变动记录
export function delDepartScoreRecord(data) {
  return request({
    url: '/hospital/departScoreRecord/delete',
    method: 'post',
    data: data
  })
}
